import { Button } from 'antd';
import { UploadFile } from 'antd/lib/upload/interface';
import React, { ReactElement, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../store';
import { setClickedOnSkip, setIsComeFromSubmit } from '../../../store/actions/newAdmissionAction';
import { NewAdmissionState } from '../../../store/models/newAdmissionModel';
import { EXTENDED_STATUS, UPLOAD_STATUS } from '../../constants/crmConstants';
const InformationSection = (): ReactElement => {
  const messageOnTime = [
    { startOn: 0, message: 'Identifying mandatory documents in the file(s)' },
    { startOn: 10000, message: 'Summarizing the Documents verified' },
  ];
  const [isUploading, setIsUploading] = useState(false);
  const [isVerifying, setIsVerifying] = useState(false);
  const [currentMessage, setCurrentMessage] = useState('');
  const [clearTime, setClearTime] = useState<any>();

  const {
    uploadedFiles: fileList, isComeFromSubmit,
  } = useSelector((state: RootState): NewAdmissionState => state.newAdmission);
  const availableFileList = fileList.filter(({ existingRecord }: any): boolean => !existingRecord);
  const dispatch = useDispatch();

  const clearSettimeout = (): void => {
    clearTimeout(clearTime);
  };

  const updateVerifyMessage = (index: number = 0): void => {
    if (index === 0) {
      clearSettimeout();
    }
    const { startOn, message } = messageOnTime[index];
    const timeObj = setTimeout((): void => {
      setCurrentMessage(message);
      if ((index + 1) < messageOnTime.length) {
        updateVerifyMessage(index + 1);
      }
    }, startOn);
    setClearTime(timeObj);
  };

  const skipValidation = (): void => {
    dispatch(setClickedOnSkip(true));
  };

  useEffect((): void => {
    if (availableFileList?.length) {
      if (availableFileList.every(({ status }: UploadFile): boolean => status === UPLOAD_STATUS.done)) {
        setIsUploading(false);
        if (availableFileList.some(({ status, extendedStatus }: any): boolean =>
          (status === UPLOAD_STATUS.done && extendedStatus === EXTENDED_STATUS.verifying))) {
          if (!isVerifying) {
            updateVerifyMessage();
          }
          setIsVerifying(true);
        } else {
          clearSettimeout();
          setIsVerifying(false);
          dispatch(setIsComeFromSubmit(false));
        }
      } else {
        setIsVerifying(false);
        setIsUploading(true);
      }
    } else {
      setIsVerifying(false);
      setIsUploading(false);
    }
  }, [fileList]);

  return (
    <div className="text-center">
      {
        (isUploading
          ? <p className="text-primary">We could identify below documents for this admission</p>
          : (isComeFromSubmit
            ? <p className="gray-text">
              It is taking longer than expected, in case you want to skip validation please click
              <Button type="link" onClick={skipValidation}>SKIP</Button>
              or let it continue. We should be done in another 5 seconds.
            </p>
            : (isVerifying
              ? <p className="text-primary">{currentMessage}</p>
              : null)))
      }
    </div>
  );
};

export default InformationSection;
